const buildEnv = process.env.NEXT_PUBLIC_BUILD_ENV;

const PROD_PATH = 'https://assets.yad2.co.il/mango/illustrations';
const DEV_PATH = 'https://dev-assets.yad2.co.il/mango/illustrations';

export const BASE_PATH = buildEnv === 'production' ? PROD_PATH : DEV_PATH;
